<div class="col-sm-12">
  <app-vcall-doc-lookup
    [initialProviderList$]="initialList"
    (notifyProviderLookup)="getUpdatedDrList($event)"
    [clientNumber]="selectedItem.clientNo"
  >
  </app-vcall-doc-lookup>
</div>
